export default "__VITE_ASSET__DXmH4Zwx__"